import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { bulkIncreaseStudentGrade, fetchStudents } from "../studentSlice";
import GradeIncreasePreviewModal from "./GradeIncreasePreviewModal";
import GradeIncreaseConfirmModal from "./GradeIncreaseConfirmModal";

const GradeIncreaseButton = () => {
  const dispatch = useDispatch();
  const { allStudents, loading } = useSelector((state) => state.student);

  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [eligibleStudents, setEligibleStudents] = useState([]);

  const handleButtonClick = () => {
    // Filter students with grade < 12
    const eligible = allStudents.filter((s) => s.grade < 12);

    if (eligible.length === 0) {
      alert("증가할 학년의 학생이 없습니다.");
      return;
    }

    setEligibleStudents(eligible);
    setIsPreviewModalOpen(true);
  };

  const handlePreviewConfirm = () => {
    setIsPreviewModalOpen(false);
    setIsConfirmModalOpen(true);
  };

  const handlePreviewCancel = () => {
    setIsPreviewModalOpen(false);
    setEligibleStudents([]);
  };

  const handleFinalConfirm = async () => {
    const result = await dispatch(bulkIncreaseStudentGrade());

    if (bulkIncreaseStudentGrade.fulfilled.match(result)) {
      alert(`총 ${eligibleStudents.length}명의 학년이 증가되었습니다.`);
      setIsConfirmModalOpen(false);
      setEligibleStudents([]);
      // Refresh to ensure sync with backend
      dispatch(fetchStudents());
    } else {
      alert("학년 증가 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  const handleFinalCancel = () => {
    setIsConfirmModalOpen(false);
  };

  const styles = {
    button: {
      backgroundColor: "#2D2D2D",
      color: "#fff",
      border: "none",
      padding: "8px 24px",
      cursor: loading ? "not-allowed" : "pointer",
      borderRadius: "4px",
      fontSize: "16px",
      opacity: loading ? 0.6 : 1,
    },
  };

  return (
    <>
      <button
        style={styles.button}
        onClick={handleButtonClick}
        disabled={loading}
      >
        학년 일괄 증가
      </button>

      {isPreviewModalOpen && (
        <GradeIncreasePreviewModal
          students={eligibleStudents}
          onConfirm={handlePreviewConfirm}
          onCancel={handlePreviewCancel}
        />
      )}

      {isConfirmModalOpen && (
        <GradeIncreaseConfirmModal
          onConfirm={handleFinalConfirm}
          onCancel={handleFinalCancel}
        />
      )}
    </>
  );
};

export default GradeIncreaseButton;
